export const COMPONENT_TYPES = {
  SIGNING: "SIGNING",
  REVOKING: "REVOKING",
  BOTH: "BOTH",
};

export const SIGNING_TYPES = {
  SIGNING: "SIGNING",
  VISE: "VISE",
} as const;
